/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const progressActivityDaySchema = z.object({
  date: z.string(),
  reviewed: z.number().int(),
  knewIt: z.number().int(),
  didntKnow: z.number().int(),
  skipped: z.number().int(),
  phrases: z.number().int(),
  timeSpentMs: z.number().int(),
  pointsEarned: z.number().int(),
  enteredLearning: z.number().int(),
  enteredStrong: z.number().int(),
  enteredMastered: z.number().int(),
});

export type IProgressActivityDay = z.infer<typeof progressActivityDaySchema>;

export const progressActivityDataSchema = z.object({
  days: z.array(progressActivityDaySchema),
  today: z.string(),
  from: z.string(),
  to: z.string(),
  nextCursor: z.string().nullable(),
});

export type IProgressActivityData = z.infer<typeof progressActivityDataSchema>;

export const getProgressActivityV1ResponseSchema = createApiResponseSchema(
  progressActivityDataSchema,
) as z.ZodSchema<IAPI<IProgressActivityData>>;

export type IGetProgressActivityV1Response = IAPI<IProgressActivityData>;
